import showActionNotification from './showActionNotification';

const showNotification = (
  promise,
  textSuccess: string,
  textError: string
) => { // eslint-disable-line max-params
  promise
    .then(res => {
      if (res?.status === 200) {
        showActionNotification({ type: 'success', message: textSuccess });
      }
    })
    .catch(() => {
      showActionNotification({ type: 'error', message: textError });
    });
};

export default showNotification;
